export enum OrdersActionTypes {
  API_RESPONSE_SUCCESS = '@@orders/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@orders/API_RESPONSE_ERROR',

  LIST_ORDERS = '@@orders/LIST_ORDERS',
  DELETE_ORDER = '@@orders/DELETE_ORDER',

  RESET = '@@orders/RESET',
}